import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell testid="reset-page" title="Choose a new password" subtitle="Enter a new password for your account.">
      {done ? (
        <div className="text-sm text-kid-navy bg-kid-skytint border border-kid-line rounded-xl px-4 py-4" data-testid="reset-done">
          Your password has been updated. Redirecting you to sign in…
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          {!token && <div className="text-sm text-kid-coral bg-red-50 border border-red-100 rounded-xl px-4 py-3">This reset link is missing its token. Please request a new one.</div>}
          {error && <div className="text-sm text-kid-coral bg-red-50 border border-red-100 rounded-xl px-4 py-3">{error}</div>}
          <div className="space-y-1.5">
            <Label htmlFor="password">New password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
                   data-testid="reset-password-input" placeholder="At least 8 characters" className="h-12 rounded-xl" />
          </div>
          <button type="submit" disabled={busy || !token} className="kid-btn kid-btn-primary w-full h-12 disabled:opacity-60" data-testid="reset-submit-button">
            {busy ? "Updating…" : "Update password"}
          </button>
          <p className="text-center text-sm text-kid-muted"><Link to="/login" className="text-kid-teal font-semibold">Back to sign in</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
